<template>
  <div v-if="!dismissPrompt && showPrompt" class="PWA_prompt">
    <div class="Modal__cross-box _cross cross-box-customer" @click="closeModal()">
      <span class="Modal__cross" />
    </div>
    クラス通知機能など便利なアプリ
    <button class="Btn__blue Btn__blue--xs _mg0 _mg-l05em font-small" @click="promptInstall">
      インストールしてみる！
    </button>
  </div>
</template>

<script>
import platform from 'platform-detect'
import Cookies from 'js-cookie'

export default {
  props: {
    deferredPrompt: {
      type: Event,
      default: null
    }
  },
  data() {
    return {
      dismissPrompt: false,
      isApp: false
    }
  },
  computed: {
    showPrompt: function() {
      return !this.isApp && platform.ios || (platform.android && this.deferredPrompt != null)
    }
  },
  created() {
    this.isApp = Cookies.get('isApp') === '1'
    if (Cookies.get('melon_pwa_prompt_dismiss')) {
      this.dismissPrompt = Cookies.get('melon_pwa_prompt_dismiss')
    }
  },
  methods: {
    promptInstall() {
      Cookies.set('melon_pwa_prompt_dismiss', true)
      this.dismissPrompt = true
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt()
        this.deferredPrompt = null
      }
      if (platform.ios) {
        window.open(process.env.VUE_APP_APPSTORE_URL, '_blank')
      }
    },
    closeModal() {
      Cookies.set('melon_pwa_prompt_dismiss', true, { expires: 7 })
      this.dismissPrompt = true
    }
  }
}
</script>
